// Runtime mirrors of the API enums (the web bundle must not import @prisma/client).

export enum VerifiedCallerIdOwnerType {
  EMPLOYEE = 'EMPLOYEE',
  COMPANY = 'COMPANY',
}

export enum VerifiedCallerIdStatus {
  PENDING = 'PENDING',
  VERIFIED = 'VERIFIED',
  FAILED = 'FAILED',
}

export enum OutboundCallerIdSource {
  EMPLOYEE = 'EMPLOYEE',
  COMPANY = 'COMPANY',
  DOUBLE_NICKEL = 'DOUBLE_NICKEL',
}

export const OUTBOUND_CALLER_ID_SOURCE_LABEL: Record<
  OutboundCallerIdSource,
  string
> = {
  [OutboundCallerIdSource.EMPLOYEE]: 'your phone',
  [OutboundCallerIdSource.COMPANY]: 'the company line',
  [OutboundCallerIdSource.DOUBLE_NICKEL]: 'Double Nickel number',
}
